export default __webpack_public_path__ + "static/media/close.8c6fe249.svg";